import React from 'react';
import ReactDOM from 'react-dom';
import Home from './Components/Home';

import './index.css';

let element = document.getElementById("root");

ReactDOM.render(<Home />, element);